import { Box, Container, Flex, HStack, Skeleton, Stack, VStack } from '@chakra-ui/react';
import { CONTAINER_MAX_WIDTH_1 } from 'src/constants/ui';

export const ListingPageSkeleton = () => {
  return (
    <Container maxW={CONTAINER_MAX_WIDTH_1} pb={12}>
      <Box py={{ base: 4, md: 5, lg: 6 }}>
        <Skeleton height="20px" width="200px" />
      </Box>
      <Stack direction={{ base: 'column', lg: 'row' }} spacing={{ base: 3, lg: 6, xl: 8 }}>
        {/* Image gallery skeleton */}
        <Box width="100%" maxW={{ lg: '516px' }}>
          <Box width="100%" paddingBottom="100%" position="relative">
            <Skeleton
              position="absolute"
              top={0}
              left={0}
              width="100%"
              height="100%"
              maxH="516px"
              maxW="516px"
              rounded="md"
              variant="shine"
            />
          </Box>
        </Box>

        {/* Content skeleton */}
        <Flex direction="column" gap={{ base: 6, lg: 8 }} flex="1">
          <Stack spacing={{ base: 3, md: 4 }}>
            <VStack spacing="3" align="flex-start">
              <Skeleton height="36px" width="80%" />
              <Skeleton height="20px" width="40%" />
            </VStack>

            <HStack>
              <Skeleton borderRadius="full" boxSize="8" />
              <Skeleton height="20px" width="120px" />
            </HStack>
          </Stack>

          <Stack spacing={3}>
            <Skeleton height="24px" width="60%" />
            <Skeleton height="20px" width="40%" />
          </Stack>

          <Stack spacing={3}>
            <Skeleton height="100px" />
            <Skeleton height="20px" width="70%" />
            <Skeleton height="20px" width="60%" />
          </Stack>

          <Stack spacing={3}>
            <Skeleton height="48px" width="100%" />
          </Stack>
        </Flex>
      </Stack>
    </Container>
  );
};
